import { Component, HostBinding } from '@angular/core'
import { Router } from '@angular/router'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { MessagingClient, MessagingMessage } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'messaging-app',
   templateUrl: './messaging-app.component.html',
   styleUrls: ['./messaging-app.component.scss'],
   standalone: false,
})
export class MessagingAppComponent {
   @HostBinding('class.full-flex-height') fullFlexHeight = true

   selectedDate: Date = new Date()
   messages: MessagingMessage[] = []
   filteredMessages: MessagingMessage[] = [] // filtered list to display
   filterText: string = ''

   isSendingMessages: boolean = false
   hasMessagesToShow: boolean = true

   constructor(private authMgr: AuthManager, private router: Router, private messagingClient: MessagingClient) {
      this.authMgr.getCurrentUser().subscribe((user) => {})
   }

   ngOnInit(): void {
      //   this.getAllMessages()
      const today = new Date()
      const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate())
      this.getMessagesByDate(todayDateOnly)
   }

   getAllMessages() {
      this.messagingClient.getAllMessages().subscribe({
         next: (data) => {
            console.log('getAllMessages()' + data)
            this.messages = data
            this.filteredMessages = this.messages
         },
         error: () => {
            console.error('ERROR: Could not get messages.')
         },
      })
   }

   getMessagesByDate(date: Date) {
      //   const formattedDate = date.toISOString().slice(0, 10) // "yyyy-MM-dd"

      this.messagingClient.getMessagesByDate(date).subscribe({
         next: (data) => {
            console.log('getMessagesByDate() data:', data)
            this.messages = data
            this.filteredMessages = this.messages

            this.hasMessagesToShow = data && data.length > 0
            console.log('hasMessagesToShow', this.hasMessagesToShow)
         },
         error: () => {
            console.error('ERROR: Could not get messages.')
         },
      })
   }

   sendTestMessaging() {
      console.log('sendTestMessaging()')
      this.isSendingMessages = true

      this.messagingClient.sendAutomatedMessages().subscribe({
         next: (data) => {
            console.log('Sent test message - ' + data)
            this.getMessagesByDate(null)
            this.isSendingMessages = false
         },
         error: () => {
            console.error('ERROR: Could not send test message.')
         },
      })
   }

   filterMessages() {
      const filter = this.filterText.toLowerCase().trim()

      this.filteredMessages = this.messages.filter((m) => {
         const phoneMatches = m.phone && m.phone.toLowerCase().includes(filter)
         const nameMatches = (m.firstName && m.firstName.toLowerCase().includes(filter)) || (m.lastName && m.lastName.toLowerCase().includes(filter))

         return phoneMatches || nameMatches
      })
   }
}
